import React, { useState } from "react";
import { db } from "../../../services/firebase";
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";

function Spinner() {
  return (
    <span
      className="inline-block h-4 w-4 border-2 border-white/70 border-t-transparent rounded-full animate-spin mr-2"
      aria-hidden="true"
    />
  );
}

export default function DefaultCard({ job }) {
  const [notes, setNotes] = useState(job?.notes || "");
  const [saving, setSaving] = useState(false);
  const [flash, setFlash] = useState(""); // "Saved" | "Completed" | ""

  async function setStatus(status) {
    setSaving(true);
    try {
      await updateDoc(doc(db, "jobs", job.id), {
        status,
        notes,
        updatedAt: serverTimestamp(),
      });
      setFlash(status === "completed" ? "Completed" : "Saved");
      setTimeout(() => setFlash(""), 1800);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mt-4 rounded-2xl border border-gray-200 bg-white shadow-sm p-4 sm:p-6 space-y-4">
      {/* Header */}
      <div className="flex flex-col gap-1">
        <h3 className="text-lg sm:text-xl font-semibold text-gray-900">
          {job.jobTypeName || "Job"}
        </h3>
        <p className="text-xs text-gray-500">
          Basic job card. Use notes to record what you have done.
        </p>
      </div>

      {/* Address */}
      <div className="space-y-1 text-sm text-gray-700">
        <div className="text-xs font-medium uppercase text-gray-500">
          Address
        </div>
        <div className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2">
          {job.address?.line1 || job.address || "–"}
        </div>
      </div>

      {/* Notes */}
      <div>
        <label className="block text-sm font-medium text-gray-800 mb-1">
          Notes
        </label>
        <textarea
          className="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-emerald-400 focus:border-emerald-400"
          rows={3}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
      </div>

      {/* Actions */}
      <div className="pt-2 flex flex-wrap items-center gap-2">
        <button
          className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 transition disabled:opacity-60"
          disabled={saving}
          onClick={() => setStatus("in_progress")}
        >
          {saving && flash !== "Completed" && <Spinner />}
          {saving && flash !== "Completed" ? "Saving..." : "Save"}
        </button>

        <button
          className="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700 transition disabled:opacity-60"
          disabled={saving}
          onClick={() => setStatus("completed")}
        >
          {saving && flash === "Completed" && <Spinner />}
          {saving && flash === "Completed" ? "Completing..." : "Complete"}
        </button>

        {flash && (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-emerald-100 text-emerald-800">
            {flash}
          </span>
        )}
      </div>
    </div>
  );
}
